module.exports = __webpack_public_path__ + "img/basic_wrinklegel_202308.e380c98a.jpg";